import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import DynamicBreadcrumbs from "../../../Uitiles/DynamicBreadcrumbs";
import PageSerch from "../SerchDocters/Components/PageSerch";
import { oneKlicks } from "../../../SDK/oneclick";
import { encryptId, registerapi } from "../../../services/apiService";
import { FaEye, FaEyeSlash } from "react-icons/fa"; // Add this import for eye icons
import 'leaflet/dist/leaflet.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from "react-toastify";
import LeafletMap from "./LeafletMap";
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { useAuth } from "../../../context/AuthContext";
import { Link } from "react-router-dom";
import './MobileRegisterScreen.css'; // Import clean minimal CSS
import ImageShow from "../../../Uitiles/ImageShow";
import { getSettings } from "../../../services/settingsService";


// Helper function to generate random string for CSRF token
const generateRandomString = (length) => {
    const array = new Uint8Array(length);
    window.crypto.getRandomValues(array);
    return Array.from(array, byte => byte.toString(16).padStart(2, '0')).join('');
};

// Helper function to hash password
const hashPassword = async (password) => {
    const encoder = new TextEncoder();
    const data = encoder.encode(password);
    const hash = await window.crypto.subtle.digest('SHA-256', data);
    return Array.from(new Uint8Array(hash))
        .map(b => b.toString(16).padStart(2, '0'))
        .join('');
};



const RegisterScreen = () => {
    const navigate = useNavigate();
    const { login } = useAuth();
    const [location, setLocation] = useState({ lat: 0, lng: 0 }); // Initial fallback coordinates
    const [address, setAddress] = useState("");
    const [selectedUserType, setSelectedUserType] = useState("doctors"); // Default selection aligned with radio value
    const mapRef = useRef(null);
    const searchInputRef = useRef(null);
    const autocompleteRef = useRef(null);
    const markerRef = useRef(null);
    const mapInstance = useRef(null);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 700);
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [settings, setSettings] = useState({});
    useEffect(() => {
        getSettings().then(settings => {
            setSettings(settings);
        });
    }, []);

    const [formData, setFormData] = useState({
        first_name: "",
        last_name: "",
        username: "",
        email: "",
        location_lat: "",
        location_lng: "",
        password: "",
        conform_password: "",
        display_name: "",
        termsconditions: false,
        phoneNumber: "",
    });

    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    useEffect(() => {
        const handleResize = () => {
            const width = window.innerWidth;
            setIsMobile(width < 700);
        };

        // Initial check
        handleResize();

        // Add event listener
        window.addEventListener('resize', handleResize);

        // Cleanup
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        setErrors({});

        const { first_name, last_name, username, email, display_name, termsconditions, phoneNumber } = formData;

        // Enhanced validation
        const newErrors = {};

        // Name validation
        if (!first_name.trim()) {
            newErrors.first_name = "First name is required.";
            toast.error("First name is required.");
        } else if (!/^[a-zA-Z\s]{2,50}$/.test(first_name)) {
            newErrors.first_name = "First name should only contain letters and spaces (2-50 characters).";
            toast.error("First name should only contain letters and spaces (2-50 characters).");
        }

        if (!last_name.trim()) {
            newErrors.last_name = "Last name is required.";
            toast.error("Last name is required.");
        } else if (!/^[a-zA-Z\s]{2,50}$/.test(last_name)) {
            newErrors.last_name = "Last name should only contain letters and spaces (2-50 characters).";
            toast.error("Last name should only contain letters and spaces (2-50 characters).");
        }

        // Email validation
        if (!email) {
            newErrors.email = "Email is required.";
            toast.error("Email is required.");
        } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email)) {
            newErrors.email = "Please enter a valid email address.";
            toast.error("Please enter a valid email address.");
        }

        // Password validation
        if (!password) {
            newErrors.password = "Password is required.";
            toast.error("Password is required.");
        } else if (password.length < 8) {
            newErrors.password = "Password must be at least 8 characters long.";
            toast.error("Password must be at least 8 characters long.");
        } else if (!/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/.test(password)) {
            newErrors.password = "Password must contain at least one uppercase letter, one lowercase letter, and one number.";
            toast.error("Password must contain at least one uppercase letter, one lowercase letter, and one number.");
        }

        if (password !== confirmPassword) {
            newErrors.conform_password = "Passwords do not match.";
            toast.error("Passwords do not match.");
        }

        if (!/^[a-zA-Z0-9]+$/.test(username)) {
            newErrors.username = "Username can only contain letters and numbers.";
            toast.error("Username can only contain letters and numbers.");
        }

        if (!phoneNumber || phoneNumber.trim() === '') {
            newErrors.phoneNumber = "Phone number is required.";
            toast.error("Phone number is required.");
        } else if (!/^\+?[1-9]\d{7,14}$/.test(phoneNumber)) {
            newErrors.phoneNumber = "Please enter a valid international phone number with country code.";
            toast.error("Please enter a valid international phone number with country code.");
        }

        if (!display_name) {
            newErrors.display_name = "Display name is required.";
            toast.error("Display name is required.");
        } else if (!/^[a-zA-Z0-9\s]{2,50}$/.test(display_name)) {
            newErrors.display_name = "Display name should only contain letters, numbers, and spaces (2-50 characters).";
            toast.error("Display name should only contain letters, numbers, and spaces (2-50 characters).");
        }

        if (!termsconditions) {
            newErrors.termsconditions = "You must accept the Terms & Conditions.";
            toast.error("You must accept the Terms & Conditions.");
        }
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            setLoading(false);
            return;
        }

        try {
            // Generate CSRF token
            const csrfToken = generateRandomString(32);
            localStorage.setItem('csrfToken', csrfToken);

            // Hash password before sending
            const hashedPassword = await hashPassword(password);

            // Prepare data
            const registrationData = {
                username,
                email,
                first_name,
                last_name,
                display_name,
                address,
                password: password,
                conform_password: confirmPassword,
                user_type: selectedUserType,
                termsconditions,
                lat: location.lat,
                lng: location.lng,
                csrfToken,
                phoneNumber,
            };

            const response = await registerapi(
                registrationData.username,
                registrationData.email,
                registrationData.first_name,
                registrationData.last_name,
                registrationData.display_name,
                registrationData.address,
                registrationData.password,
                registrationData.conform_password,
                registrationData.user_type,
                registrationData.termsconditions,
                registrationData.lat,
                registrationData.lng,
                registrationData.phoneNumber,
                registrationData.csrfToken
            );

            console.log("Registration response:", response);

            if (response.success === true) {
                const userData = {
                    id: response.insertedData.id,
                    email: response.insertedData.email,
                    user_type: response.insertedData.user_type,
                    display_name: response.insertedData.display_name || response.insertedData.email
                };

                // Use the login function from AuthContext
                const loginSuccess = await login(userData);

                if (loginSuccess) {
                    toast.success("Registration successful!");
                    formData.first_name = "";
                    formData.last_name = "";
                    formData.username = "";
                    formData.email = "";
                    formData.password = "";
                    formData.conform_password = "";
                    formData.display_name = "";
                    formData.termsconditions = false;


                    localStorage.setItem("user", JSON.stringify(userData));
                    localStorage.setItem('presentuser', JSON.stringify(userData));

                    // Navigate based on user type
                    if (response.insertedData.user_type === "doctor" || response.insertedData.user_type === "doctors") {
                        navigate(`/doctor/dashboard/${encryptId(response.insertedData.id)}`);
                    }
                    else if (response.insertedData.user_type === "hospitals") {
                        navigate("/hospital/dashboard");
                    }
                    else if (response.insertedData.user_type === "regular_users" || response.insertedData.user_type === "patient" || response.insertedData.user_type === "user") {
                        navigate("/user-dashboard");
                    }
                    else if (response.insertedData.user_type === "seller" || response.insertedData.user_type === "pharmacy") {
                        navigate("/pharmacy/dashboard");
                    }
                    else if (response.insertedData.user_type === "diagnostic") {
                        navigate("/diagnostic-dashboard");
                    }
                    else if (response.insertedData.user_type === "blood_bank") {
                        navigate("/blood-bank-dashboard");
                    }
                    else if (response.insertedData.user_type === "ambulance") {
                        navigate("/ambulance-dashboard");
                    }
                    else if (response.insertedData.user_type === "insurance") {
                        navigate("/insurance-dashboard");
                    }
                    else {
                        navigate("/user-dashboard");
                    }
                } else {
                    toast.error("Auto-login failed. Please try logging in manually.");
                    navigate("/login");
                }
            } else {
                if (response.details === "Duplicate column name 'login'") {
                    toast.error("Username already exists. Please choose another one.");
                } else if (response.details === "Duplicate column name 'email'") {
                    toast.error("Email already exists. Please choose another one.");
                } else {
                    toast.error(response.message || "Registration failed. Please try again.");
                }
                console.error("Registration Failed:", response.details);
            }
        } catch (error) {
            console.error("Registration error:", error);
            toast.error("An unexpected error occurred.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        // Fetch user location
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const { latitude, longitude } = position.coords;
                    setLocation({ lat: latitude, lng: longitude });
                },
                (error) => {
                    console.error("Error fetching location:", error);
                    switch (error.code) {
                        case error.PERMISSION_DENIED:
                            alert("Permission denied. Please allow location access.");
                            break;
                        case error.POSITION_UNAVAILABLE:
                            alert("Location unavailable.");
                            break;
                        case error.TIMEOUT:
                            alert("Request timed out. Please try again.");
                            break;
                        default:
                            alert("An unknown error occurred.");
                    }
                    // Set fallback location (e.g., Nellore)
                    setLocation({ lat: 14.4426, lng: 79.9865 });
                }
            );
        } else {
            alert("Geolocation is not supported by this browser.");
            // Set fallback location
            setLocation({ lat: 14.4426, lng: 79.9865 });
        }
    }, []);

    useEffect(() => {
        const loadMap = async () => {
            if (location.lat === 0 && location.lng === 0) return;

            const { Map } = await window.google.maps.importLibrary("maps");
            const { AdvancedMarkerElement } = await window.google.maps.importLibrary("marker");
            const { PlaceAutocompleteElement } = await window.google.maps.importLibrary("places");

            if (!mapInstance.current) {
                mapInstance.current = new Map(mapRef.current, {
                    center: location,
                    zoom: 15,
                });

                markerRef.current = new AdvancedMarkerElement({
                    map: mapInstance.current,
                    position: location,
                    title: "Drag to adjust",
                    gmpDraggable: true,
                });

                markerRef.current.addListener("dragend", (e) => {
                    const lat = e.latLng.lat();
                    const lng = e.latLng.lng();
                    setLocation({ lat, lng });
                });

                mapInstance.current.addListener("click", (e) => {
                    const lat = e.latLng.lat();
                    const lng = e.latLng.lng();
                    setLocation({ lat, lng });
                    markerRef.current.position = { lat, lng };
                });

                // Modern autocomplete setup
                autocompleteRef.current = new PlaceAutocompleteElement();
                searchInputRef.current.appendChild(autocompleteRef.current);

                autocompleteRef.current.addEventListener("gmp-placechange", () => {
                    const place = autocompleteRef.current.getPlace();
                    if (place && place.location) {
                        const { lat, lng } = place.location;
                        setLocation({ lat, lng });
                        mapInstance.current.setCenter({ lat, lng });
                        markerRef.current.position = { lat, lng };
                    }
                });
            } else {
                mapInstance.current.setCenter(location);
                markerRef.current.position = location;
            }
        };

        loadMap();
    }, [location]);




    const handleUserTypeChange = (e) => {
        const userType = e.target.value;
        setSelectedUserType(userType);
    };

    const getPlaceholder = () => {
        switch (selectedUserType) {
            case "hospitals":
                return "Enter Hospital Name";
            case "doctors":
                return "Enter Doctor Name";
            case "user":
                return "Enter Patient Name";
            case "seller":
                return "Enter Store Name";
            case "diagnostic":
                return "Enter Diagnostic Center Name";
            case "blood_bank":
                return "Enter Blood Bank Name";
            case "ambulance":
                return "Enter Ambulance Service Name";
            case "insurance":
                return "Enter Insurance Provider Name";
            default:
                return "Enter Your Name";
        }
    };


    return (
        <>
            <main id="dc-main" className="mobile-register dc-main dc-haslayout">
                <div className="mobile-register container">
                    <div className="mobile-register dc-haslayout dc-haslayout page-data dc-parent-section dc-disabled">
                        <div className="mobile-register main-page-wrapper">
                            <div className="mobile-register dc-description">
                                <div
                                    data-elementor-type="wp-page"
                                    data-elementor-id="1238"
                                    className="mobile-register elementor elementor-1238"
                                >
                                    <section
                                        className="mobile-register elementor-section elementor-top-section elementor-element elementor-element-68f584f elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                                        data-id="68f584f"
                                        data-element_type="section"
                                    >
                                        <div className="mobile-register elementor-container elementor-column-gap-no">
                                            <div
                                                className="mobile-register elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-9decf63"
                                                data-id="9decf63"
                                                data-element_type="column"
                                            >
                                                <div className="mobile-register elementor-widget-wrap elementor-element-populated">
                                                    <div
                                                        className="mobile-register elementor-element elementor-element-d3163c4 elementor-widget elementor-widget-wt_element_authentication"
                                                        data-id="d3163c4"
                                                        data-element_type="widget"
                                                        data-widget_type="wt_element_authentication.default"
                                                    >
                                                        <div className="mobile-register elementor-widget-container">
                                                            <div className="mobile-register dc-sc-shortcode dc-haslayout">
                                                                <div className="mobile-register dc-haslayout dc-parent-section">
                                                                    <div className="mobile-register row justify-content-md-center">
                                                                        <div className="mobile-register col-xs-12 col-sm-12 col-md-10 push-md-1 col-lg-8 push-lg-2">
                                                                            <div className="mobile-register dc-modalcontent modal-content register_bodey">
                                                                                <div className="mobile-register dc-registerformholds">
                                                                                    {/* Header with Logo */}
                                                                                    <div className="mobile-register dc-registerheader">
                                                                                        <div className="register-logo">
                                                                                            <ImageShow url={settings.favicon_url} height={0} width={0} />
                                                                                        </div>
                                                                                        <span>Create Account</span>
                                                                                        <p className="welcome-message">
                                                                                            Fill your information below or register with your social account.
                                                                                        </p>
                                                                                    </div>

                                                                                    {/* Registration Form */}
                                                                                    <form className="mobile-register dc-formtheme dc-registerform" onSubmit={handleSubmit}>
                                                                                        <div className="mobile-register dc-joinforms">
                                                                                            <fieldset className="mobile-register dc-registerformgroup">
                                                                                                <div className="mobile-register form-group form-group-half">
                                                                                                    <label htmlFor="first_name" className="mobile-register form-label">First Name</label>
                                                                                                    <input
                                                                                                        type="text"
                                                                                                        name="first_name"
                                                                                                        className="mobile-register form-control"
                                                                                                        value={formData.first_name}
                                                                                                        placeholder="First Name"
                                                                                                        onChange={handleChange}
                                                                                                    />
                                                                                                    {errors.first_name && (
                                                                                                        <small className="mobile-register text-danger">{errors.first_name}</small>
                                                                                                    )}
                                                                                                </div>
                                                                                                <div className="mobile-register form-group form-group-half">
                                                                                                    <label htmlFor="last_name" className="mobile-register form-label">Last Name</label>
                                                                                                    <input
                                                                                                        type="text"
                                                                                                        name="last_name"
                                                                                                        className="mobile-register form-control"
                                                                                                        value={formData.last_name}
                                                                                                        placeholder="Last Name"
                                                                                                        onChange={handleChange}
                                                                                                    />
                                                                                                    {errors.last_name && (
                                                                                                        <small className="mobile-register text-danger">{errors.last_name}</small>
                                                                                                    )}
                                                                                                </div>
                                                                                                <div className="mobile-register form-group form-group-half">
                                                                                                    <label htmlFor="phoneNumber" className="mobile-register form-label">Phone Number</label>
                                                                                                    <PhoneInput
                                                                                                        international
                                                                                                        defaultCountry="IN"
                                                                                                        value={formData.phoneNumber}
                                                                                                        onChange={phoneNumber => setFormData({ ...formData, phoneNumber })}
                                                                                                        placeholder="Enter phone number"
                                                                                                        className="mobile-register form-control"
                                                                                                    />
                                                                                                    {errors.phoneNumber && (
                                                                                                        <small className="mobile-register text-danger">{errors.phoneNumber}</small>
                                                                                                    )}
                                                                                                </div>

                                                                                                <div className="mobile-register form-group form-group-half">
                                                                                                    <label htmlFor="username" className="mobile-register form-label">Username</label>
                                                                                                    <input
                                                                                                        type="text"
                                                                                                        name="username"
                                                                                                        className="mobile-register form-control"
                                                                                                        value={formData.username}
                                                                                                        placeholder="Username"
                                                                                                        onChange={handleChange}
                                                                                                    />
                                                                                                    {errors.username && (
                                                                                                        <small className="mobile-register text-danger">{errors.username}</small>
                                                                                                    )}
                                                                                                </div>
                                                                                                <div className="mobile-register form-group form-group-half">
                                                                                                    <label htmlFor="email" className="mobile-register form-label">Email</label>
                                                                                                    <input
                                                                                                        type="email"
                                                                                                        name="email"
                                                                                                        className="mobile-register form-control"
                                                                                                        value={formData.email}
                                                                                                        placeholder="Email"
                                                                                                        onChange={handleChange}
                                                                                                    />
                                                                                                    {errors.email && (
                                                                                                        <small className="mobile-register text-danger">{errors.email}</small>
                                                                                                    )}
                                                                                                </div>
                                                                                            </fieldset>
                                                                                            <LeafletMap setLocation={setLocation} setAddress={setAddress} location={location} address={address} isMobile={isMobile} />

                                                                                            <fieldset className="mobile-register dc-registerformgroup">
                                                                                                <div className="mobile-register form-group form-group-half position-relative">
                                                                                                    <label htmlFor="password" className="mobile-register form-label">Password</label>
                                                                                                    <input
                                                                                                        className="mobile-register form-control"
                                                                                                        placeholder="Password"
                                                                                                        type={passwordVisible ? 'text' : 'password'}
                                                                                                        value={password}
                                                                                                        onChange={(e) => setPassword(e.target.value)}
                                                                                                        name="password"
                                                                                                    />
                                                                                                    <button
                                                                                                        type="button"
                                                                                                        className="mobile-register btn btn-link position-absolute"
                                                                                                        style={{ top: '20px', right: '15px', padding: 0, color: '#666' }}
                                                                                                        onClick={() => setPasswordVisible(!passwordVisible)}
                                                                                                    >
                                                                                                        {passwordVisible ? <FaEyeSlash /> : <FaEye />}
                                                                                                    </button>
                                                                                                    {errors.password && (
                                                                                                        <small className="mobile-register text-danger">{errors.password}</small>
                                                                                                    )}
                                                                                                </div>

                                                                                                <div className="mobile-register form-group form-group-half position-relative">
                                                                                                    <label htmlFor="confirm_password" className="mobile-register form-label">Confirm Password</label>
                                                                                                    <input
                                                                                                        className="mobile-register form-control"
                                                                                                        placeholder="Confirm Password"
                                                                                                        type={confirmPasswordVisible ? 'text' : 'password'}
                                                                                                        value={confirmPassword}
                                                                                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                                                                                        name="confirm_password"
                                                                                                    />
                                                                                                    <button
                                                                                                        type="button"
                                                                                                        className="mobile-register btn btn-link position-absolute"
                                                                                                        style={{ top: '20px', right: '15px', padding: 0, color: '#666' }}
                                                                                                        onClick={() => setConfirmPasswordVisible(!confirmPasswordVisible)}
                                                                                                    >
                                                                                                        {confirmPasswordVisible ? <FaEyeSlash /> : <FaEye />}
                                                                                                    </button>
                                                                                                    {errors.conform_password && (
                                                                                                        <small className="mobile-register text-danger">{errors.conform_password}</small>
                                                                                                    )}
                                                                                                </div>
                                                                                            </fieldset>
                                                                                            <fieldset className="mobile-register dc-formregisterstart">
                                                                                                <div className="mobile-register dc-title dc-formtitle">
                                                                                                    <h4>Start as:</h4>
                                                                                                </div>
                                                                                                <ul className="mobile-register dc-startoption">
                                                                                                    <li>
                                                                                                        <span className="dc-radio" data-display="Hospital Details">
                                                                                                            <input
                                                                                                                id="dc-hospitals"
                                                                                                                type="radio"
                                                                                                                name="user_type"
                                                                                                                value="hospitals"
                                                                                                                checked={selectedUserType === "hospitals"}
                                                                                                                onChange={handleUserTypeChange}
                                                                                                            />
                                                                                                            <label htmlFor="dc-hospitals">Hospital</label>
                                                                                                        </span>
                                                                                                    </li>
                                                                                                    <li>
                                                                                                        <span className="dc-radio" data-display="Doctor Profile">
                                                                                                            <input
                                                                                                                id="dc-doctors"
                                                                                                                type="radio"
                                                                                                                name="user_type"
                                                                                                                value="doctors"
                                                                                                                checked={selectedUserType === "doctors"}
                                                                                                                onChange={handleUserTypeChange}
                                                                                                            />
                                                                                                            <label htmlFor="dc-doctors">Doctor</label>
                                                                                                        </span>
                                                                                                    </li>
                                                                                                    <li>
                                                                                                        <span className="dc-radio" data-display="Insurance Provider">
                                                                                                            <input
                                                                                                                id="dc-insurance"
                                                                                                                type="radio"
                                                                                                                name="user_type"
                                                                                                                value="insurance"
                                                                                                                checked={selectedUserType === "insurance"}
                                                                                                                onChange={handleUserTypeChange}
                                                                                                            />
                                                                                                            <label htmlFor="dc-insurance">Insurance Provider</label>
                                                                                                        </span>
                                                                                                    </li>
                                                                                                    <li>
                                                                                                        <span className="dc-radio" data-display="Patient Profile">
                                                                                                            <input
                                                                                                                id="dc-regular_users"
                                                                                                                type="radio"
                                                                                                                name="user_type"
                                                                                                                value="user"
                                                                                                                checked={selectedUserType === "user"}
                                                                                                                onChange={handleUserTypeChange}
                                                                                                            />
                                                                                                            <label htmlFor="dc-regular_users">Patient</label>
                                                                                                        </span>
                                                                                                    </li>
                                                                                                    <li>
                                                                                                        <span className="dc-radio" data-display="Store Name">
                                                                                                            <input
                                                                                                                id="dc-seller"
                                                                                                                type="radio"
                                                                                                                name="user_type"
                                                                                                                value="seller"
                                                                                                                checked={selectedUserType === "seller"}
                                                                                                                onChange={handleUserTypeChange}
                                                                                                            />
                                                                                                            <label htmlFor="dc-seller">Pharmacy (Vendor)</label>
                                                                                                        </span>
                                                                                                    </li>
                                                                                                    <li>
                                                                                                        <span className="dc-radio" data-display="Diagnostic Center">
                                                                                                            <input
                                                                                                                id="dc-diagnostic"
                                                                                                                type="radio"
                                                                                                                name="user_type"
                                                                                                                value="diagnostic"
                                                                                                                checked={selectedUserType === "diagnostic"}
                                                                                                                onChange={handleUserTypeChange}
                                                                                                            />
                                                                                                            <label htmlFor="dc-diagnostic">Diagnostic</label>
                                                                                                        </span>
                                                                                                    </li>
                                                                                                    <li>
                                                                                                        <span className="dc-radio" data-display="Blood Bank Info">
                                                                                                            <input
                                                                                                                id="dc-blood_bank"
                                                                                                                type="radio"
                                                                                                                name="user_type"
                                                                                                                value="blood_bank"
                                                                                                                checked={selectedUserType === "blood_bank"}
                                                                                                                onChange={handleUserTypeChange}
                                                                                                            />
                                                                                                            <label htmlFor="dc-blood_bank">Blood Bank</label>
                                                                                                        </span>
                                                                                                    </li>
                                                                                                    <li>
                                                                                                        <span className="dc-radio" data-display="Enter Your Name">
                                                                                                            <input
                                                                                                                id="dc-ambulance"
                                                                                                                type="radio"
                                                                                                                name="user_type"
                                                                                                                value="ambulance"
                                                                                                                checked={selectedUserType === "ambulance"}
                                                                                                                onChange={handleUserTypeChange}
                                                                                                            />
                                                                                                            <label htmlFor="dc-ambulance">Ambulance</label>
                                                                                                        </span>
                                                                                                    </li>
                                                                                                </ul>
                                                                                                <div className="mobile-register form-group form-group-half mt-2">
                                                                                                    <label htmlFor="display_name" className="mobile-register form-label">Display Name</label>
                                                                                                    <input
                                                                                                        type="text"
                                                                                                        name="display_name"
                                                                                                        className="mobile-register form-control"
                                                                                                        value={formData.display_name}
                                                                                                        placeholder={getPlaceholder()}
                                                                                                        onChange={handleChange}
                                                                                                    />
                                                                                                    {errors.display_name && (
                                                                                                        <small className="mobile-register text-danger">{errors.display_name}</small>
                                                                                                    )}
                                                                                                </div>
                                                                                            </fieldset>
                                                                                            <span className="mobile-register dc-checkbox">
                                                                                                <input
                                                                                                    id="termsconditions"
                                                                                                    type="checkbox"
                                                                                                    name="termsconditions"
                                                                                                    value="checked"
                                                                                                    checked={formData.termsconditions}
                                                                                                    onChange={handleChange}
                                                                                                />
                                                                                                <label htmlFor="termsconditions">
                                                                                                    <span>
                                                                                                        Consectetur Adipisicing Elit Sed Do Eiusmod Tempor Incididunt Ut Labore
                                                                                                        Et Dolore Magna Aliqua Enim Ad Minim Veniam Quis.{" "}
                                                                                                        <a
                                                                                                            target="_blank"
                                                                                                            href="//css.meddylist.com//how-to-work/"
                                                                                                            rel="noopener noreferrer"
                                                                                                        >
                                                                                                            Terms &amp; Conditions
                                                                                                        </a>
                                                                                                    </span>
                                                                                                </label>
                                                                                                {errors.termsconditions && (
                                                                                                    <small className="mobile-register text-danger">{errors.termsconditions}</small>
                                                                                                )}
                                                                                            </span>

                                                                                            <div className="mobile-register form-group" style={{ display: 'flex', flexDirection: 'row-reverse', marginTop: '10px' }}>
                                                                                                <button
                                                                                                    type="submit"
                                                                                                    className="mobile-register dc-btn rg-step-start"
                                                                                                    disabled={loading}
                                                                                                >
                                                                                                    {loading ? "Registering..." : "Signup Now"}
                                                                                                </button>
                                                                                            </div>

                                                                                            {errors.general && (
                                                                                                <small className="mobile-register text-danger">{errors.general}</small>
                                                                                            )}
                                                                                            <div className="mobile-register dc-registerformfooter">
                                                                                                <span>Already Have an Account?<Link to="/mobile/login" className="">&nbsp;Login Now</Link></span>
                                                                                            </div>
                                                                                        </div>
                                                                                    </form>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
            <ToastContainer position="top-right" autoClose={3000} />
        </>
    );
};

export default RegisterScreen;
